import React from "react";
import { OscInput } from "./OscInput";

export const LogoChange = ({ fileName, ...props }: Props) => {

    return (
        <div className='grid grid-cols-3 gap-x-6'>
            <div className='col-span-2'>
                <OscInput label={'Logo'} defaultValue={fileName} />
            </div>
            <div className='col-span-1 flex items-end'>
                <label htmlFor='file' className='w-full focus:outline-none text-black h-12 bord flex
            items-center justify-center cursor-pointer
            rounded-md text-center  py-2
            bg-primary'>Buscar Imagem</label>
                <input className='hidden' id='file' type='file' {...props} />
            </div>
        </div>
    )
}

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    fileName: string
}
